<template>
  <div>
    <EventIcon :status="event.status" />
    <h4>
      {{ capitalizeFilter(event.locationName) }}
    </h4>
    <p class="mb-2 text-black-50">
      {{ eventDate }}
    </p>
    <p class="delivery-route-message">
      {{ trackingStore.eventText(event.description) }}
    </p>
    <span class="country-name">
      {{ event.countryCode }}
    </span>
  </div>
</template>

<script lang="ts">
import type { TrackingEvent } from '@/types/Models/Shipment'
import { defineComponent, type PropType, type ComputedRef, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { capitalizeFilter } from '@/helpers/Utils'
import { useTrackingStore } from '@/store/modules/tracking'
import moment from 'moment'
import EventIcon from '@/views/Components/EventIcon.vue'

export default defineComponent({
  name: 'EventRouteBlock',
  components: { EventIcon },
  props: {
    event: {
      type: Object as PropType<TrackingEvent>,
      required: true,
    },
  },
  setup(props) {
    const { locale } = useI18n()
    const trackingStore = useTrackingStore()
    // Month names in the page language ("16 okt" in Swedish)
    const eventDate: ComputedRef<string> = computed(() =>
      moment(props.event.eventTime).locale(locale.value).format('D MMM HH:mm'),
    )

    return {
      capitalizeFilter,
      eventDate,
      trackingStore,
    }
  },
})
</script>
